var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionModal } from "./actionModal";
var initial = {
    modalStack: [],
};
export var createReducerModals = function (modalsConfig) { return function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionModal.Open:
            return __assign({}, state, { modalStack: state.modalStack.concat([modalsConfig[action.modalId]]) });
        case TypeActionModal.Close:
            return __assign({}, state, { modalStack: state.modalStack
                    .slice()
                    .filter(function (menu) { return menu.modalId !== action.modalId; }) });
        case TypeActionModal.CloseAll:
            return __assign({}, state, { modalStack: [] });
        case TypeActionModal.SwapLast:
            return __assign({}, state, { modalStack: state.modalStack.slice(0, state.modalStack.length - 1).concat([
                    modalsConfig[action.modalId],
                ]) });
        case TypeActionModal.TabSelect:
            return __assign({}, state, { modalStack: state.modalStack.slice(0, state.modalStack.length - 1).concat([
                    __assign({}, state.modalStack[state.modalStack.length - 1], { tabId: action.tabId }),
                ]) });
        case TypeActionModal.CloseLast:
            return __assign({}, state, { modalStack: state.modalStack.slice(0, state.modalStack.length - 1).slice() });
        default:
            return state;
    }
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/createReducerModals.ts
// module id = 2548
// module chunks = 3